/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { IdReference } from './idReference';

export type ModuleGlobalUpdateRequestAuthor = IdReference | null;
